import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet-easybutton/src/easy-button.css";
import "leaflet-easybutton/src/easy-button";
import { ContestTaskRenderer } from '../utils/ContestTaskRenderer.js';

export default class ChallengesMap {
  constructor() {
    this.map = null;
    this.bounds = null;
    this.category_id = 0;
    this.contestTasks = [];
    this.contestTasksHtml = '';
    this.currentContestTask = null;
    this.renderer = null;
    this.showAllChallenges = false;
    this.challengeInfoControl = null;

    this.marker_pointer = window.data.marker_pointer_tracker;
    this.marker_pointer_shadow = window.data.marker_pointer_shadow;

    this.doit = null;
    this.loadTimeout = null;

    // Add CSS transition for smooth opacity changes
    $("#contest-list").css("transition", "opacity 0.3s ease-in-out");

    // Marker cluster group for contest tasks
    this.markerClusterGroup = L.markerClusterGroup({
      animate: true,
      spiderfyDistanceMultiplier: 1.5,
      spiderLegPolylineOptions: { weight: 1.5, color: "#222", opacity: 0.3 },
      iconCreateFunction: (cluster) => {
        const count = cluster.getChildCount();
        return L.divIcon({
          html: `<img src="${this.marker_pointer}" style="margin-top:-28px;height: 59px;width: 47px;">
                 <div class="position-absolute w-100 text-center text-danger fw-600 fs-16" style="top:-16px;left: 0;">${count}</div>`,
          className: "challengeCluster",
          iconSize: L.point(47, 59),
        });
      },
    });

    this.initMap();
    this.bindEvents();
  }

  initMap() {
    // Don't set height via JS - let CSS handle responsive heights
    // The .challenges-map-responsive class already handles mobile vs desktop sizing

    const bounds = new L.LatLngBounds(
      new L.LatLng(85, 180),
      new L.LatLng(-85, -180)
    );

    // Get initial view from URL parameters or use defaults
    const initialView = this.getInitialViewFromUrl();

    this.map = L.map("challenges-map", {
      attributionControl: false,
      maxBounds: bounds,
      maxBoundsViscosity: 1,
      minZoom: 2,
    }).setView([initialView.lat, initialView.lng], initialView.zoom);

    L.tileLayer("https://tile.tracestrack.com/_/{z}/{x}/{y}.png?key=5b37c4cf109fa26755308c3a5e221369", {
      attribution: false,
    }).addTo(this.map);

    // Initialize the renderer
    this.renderer = new ContestTaskRenderer(this.map);

    // Add cluster layer to map
    this.map.addLayer(this.markerClusterGroup);

    // Load initial contest tasks
    this.loadContestTasks();
  }

  getInitialViewFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return {
      lat: parseFloat(params.get('lat')) || 41.831131,
      lng: parseFloat(params.get('lng')) || 15.624207,
      zoom: parseInt(params.get('zoom')) || 3
    };
  }

  updateUrlWithMapView() {
    const center = this.map.getCenter();
    const zoom = this.map.getZoom();

    const params = new URLSearchParams(window.location.search);
    params.set('lat', center.lat.toFixed(5));
    params.set('lng', center.lng.toFixed(5));
    params.set('zoom', zoom);

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  }

  bindEvents() {
    const self = this;

    // Map move/zoom events - debounced
    this.map.on("moveend zoomend", function () {
      // Update URL with current map view
      self.updateUrlWithMapView();

      clearTimeout(self.loadTimeout);
      self.loadTimeout = setTimeout(() => {
        // If we're viewing a specific contest and zoomed out, return to cluster mode
        if (self.currentContestTask && self.map.getZoom() < 10) {
          self.clearCurrentContestTask();
          self.loadContestTasks();
        } else if (!self.currentContestTask) {
          self.loadContestTasks();
        }
      }, 500);
    });

    // Window resize
    $(window).resize(function () {
      clearTimeout(self.doit);
      self.doit = setTimeout(function () {
        self.map.invalidateSize();
      }, 200);
    });

    // Contest list item click
    $(document).on("click", ".contest-item", function (e) {
      e.preventDefault();
      const contestId = parseInt($(this).data("contest-id"));
      self.loadContestTaskDetails(contestId);
    });

    // Show all challenges button
    $("#show-more-challenges").on("click", function () {
      self.showAllChallenges = true;
      $("#show-more-challenges").addClass("d-none");
      $("#contest-list").addClass("d-none");
      $("#contest-list-loader").removeClass("d-none").addClass("d-flex");

      setTimeout(() => {
        self.updateContestList();
      }, 300);
    });
  }

  loadContestTasks() {
    const bounds = this.map.getBounds();
    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    const params = {
      sw_lat: sw.lat,
      sw_lng: sw.lng,
      ne_lat: ne.lat,
      ne_lng: ne.lng,
      category_id: this.category_id,
      render_html: true
    };

    // Reset to show limited list when loading new data
    this.showAllChallenges = false;

    // Add subtle loading indicator without hiding content
    const container = $("#contest-list");
    const isFirstLoad = container.children().length === 0;

    if (isFirstLoad) {
      // Only show full loader on first load
      container.addClass("d-none");
      $("#contest-list-loader").removeClass("d-none").addClass("d-flex");
    } else {
      // For refreshes, just reduce opacity slightly
      container.css("opacity", "0.6");
    }

    fetch(`${window.application.getAPIUrl()}/v1/contest_task/challenges?${new URLSearchParams(params)}`, {
      headers: {
        "Content-Type": "application/json",
        "X-STL-Token": cookies.get("STL-Token")
      }
    })
      .then(response => response.json())
      .then(data => {
        this.contestTasks = data.contest_tasks;
        this.contestTasksHtml = data.html;
        this.updateMarkers();
        this.updateContestList();
        // Restore full opacity
        container.css("opacity", "1");
      })
      .catch(error => {
        console.error("Error loading contest tasks:", error);
        // Restore opacity and hide loader on error
        container.css("opacity", "1");
        $("#contest-list-loader").removeClass("d-flex").addClass("d-none");
        container.removeClass("d-none");
      });
  }

  updateMarkers() {
    // Clear existing markers
    this.markerClusterGroup.clearLayers();

    // Add markers for each contest task
    this.contestTasks.forEach(task => {
      if (task.latitude && task.longitude) {
        const marker = L.marker([task.latitude, task.longitude], {
          icon: this.createMarkerIcon(task)
        });

        marker.contestTaskId = task.id;

        marker.bindPopup(`
          <div class="m-2 text-center fs-12">
            <h2 class="fs-22">${task.name}</h2>            
            <a href="#" class="btn btn-sm btn-danger text-white mt-2 fs-14 contest-item" data-contest-id="${task.id}">
              ${I18n.t("website.contest_task.challenges.view_route")}
            </a>
            <a href="${task.leaderboard_url}" class="btn btn-sm btn-primary text-white mt-2 fs-14">
              ${I18n.t("website.contest_task.challenges.view_leaderboard")}
            </a>
          </div>
        `);

        this.markerClusterGroup.addLayer(marker);
      }
    });
  }

  createMarkerIcon(task) {
    return L.divIcon({
      html: `<img src="${this.marker_pointer}" style="margin-top:-28px;height: 59px;width: 47px;">
             <div class="position-absolute w-100 text-center text-secondary fw-600 fs-14" style="top:-18px;left: 0;">
               <span class="badge badge-primary">${task.participants_count}</span>
             </div>`,
      className: "contestMarker",
      iconSize: [47, 59],
    });
  }

  updateContestList() {
    const container = $("#contest-list");
    container.empty();

    $("#contest-count").text(this.contestTasks.length);

    // Hide loader and show list
    $("#contest-list-loader").removeClass("d-flex").addClass("d-none");
    $("#contest-list").removeClass("d-none");

    if (this.contestTasks.length === 0) {
      container.html(`<div class="text-center text-white py-4">${I18n.t("website.contest_task.challenges.no_challenges")}</div>`);
      $("#show-more-challenges").addClass("d-none");
      return;
    }

    // Parse the HTML into individual items
    const htmlWrapper = $('<div>').html(this.contestTasksHtml);
    const allItems = htmlWrapper.find('.contest-item').parent();

    // Determine how many items to show
    const itemsToShow = this.showAllChallenges ? allItems.length : Math.min(10, allItems.length);

    // Show "show all" button if we have more than 10 items and not showing all
    if (allItems.length > 10 && !this.showAllChallenges) {
      $("#show-more-challenges").removeClass("d-none");
    } else {
      $("#show-more-challenges").addClass("d-none");
    }

    // Add items to container
    allItems.slice(0, itemsToShow).each((_index, element) => {
      container.append(element);
    });
  }

  loadContestTaskDetails(contestId) {
    // Simply show the contest task - the renderer will fetch data
    this.showContestTask(contestId);
  }

  showContestTask(contestId) {
    this.currentContestTask = contestId;

    // Hide cluster markers
    this.map.removeLayer(this.markerClusterGroup);

    // Clear existing contest task layers if any
    this.clearRendererLayers();

    // Find the selected challenge data
    const challenge = this.contestTasks.find(t => t.id === contestId);

    // Show challenge info popup
    if (challenge) {
      this.showChallengeInfo(challenge);
    }

    // Use the renderer to load and display the contest task
    this.renderer.renderFromAPI(contestId, () => {
      // Callback executed after task is rendered
      // Fit bounds to the rendered task
      if (this.renderer && this.renderer.taskLayers && this.renderer.taskLayers.length > 0) {
        const group = L.featureGroup(this.renderer.taskLayers);
        this.map.fitBounds(group.getBounds(), {
          padding: [50, 50],
          maxZoom: 13
        });
      }
    });

    // Highlight selected contest in list
    $(".contest-item").removeClass("bg-danger text-white");
    $(".contest-item").addClass("bg-light");
    $(".contest-item .task-icon-button").removeClass("bg-primary").addClass("bg-secondary");
    $(".contest-item .user-link").removeClass("text-white");

    const selectedItem = $(`.contest-item[data-contest-id="${contestId}"]`);
    selectedItem.removeClass("bg-light");
    selectedItem.addClass("bg-danger text-white");
    selectedItem.find(".task-icon-button").removeClass("bg-secondary").addClass("bg-primary");
    selectedItem.find(".user-link").addClass("text-white");
  }

  showChallengeInfo(challenge) {
    // Remove existing control if any
    this.hideChallengeInfo();

    // Create custom control
    const ChallengeInfoControl = L.Control.extend({
      options: {
        position: 'topright'
      },

      onAdd: function(map) { // eslint-disable-line no-unused-vars
        const container = L.DomUtil.create('div', 'leaflet-control challenge-info-popup');
        container.style.background = 'white';
        container.style.padding = '15px 20px';
        container.style.borderRadius = '8px';
        container.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';
        container.style.minWidth = '280px';
        container.style.maxWidth = '350px';

        container.innerHTML = `
          <div class="mb-2">
            <h4 class="mb-0 fs-24 text-center">${challenge.name}</h4>
          </div>
          <div class="mt-3">
            <a href="${challenge.leaderboard_url}" class="btn btn-block btn-danger text-white fs-14 fw-600 py-2"><span class="mdi mdi-trophy pr-1"></span>${I18n.t("website.contest_task.challenges.view_route")}</a>
          </div>
        `;

        // Prevent map interactions when clicking on the popup
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);

        return container;
      }
    });

    this.challengeInfoControl = new ChallengeInfoControl();
    this.challengeInfoControl.addTo(this.map);
  }

  hideChallengeInfo() {
    if (this.challengeInfoControl) {
      this.map.removeControl(this.challengeInfoControl);
      this.challengeInfoControl = null;
    }
  }

  clearRendererLayers() {
    // Remove all layers from the renderer
    if (this.renderer && this.renderer.taskLayers) {
      this.renderer.taskLayers.forEach(layer => {
        this.map.removeLayer(layer);
      });
      this.renderer.taskLayers = [];
    }
  }

  clearCurrentContestTask() {
    this.currentContestTask = null;

    // Remove challenge info popup
    this.hideChallengeInfo();

    // Remove contest task layers from renderer
    this.clearRendererLayers();

    // Show cluster markers again
    this.map.addLayer(this.markerClusterGroup);

    // Remove highlight from list
    $(".contest-item").removeClass("bg-danger text-white");
    $(".contest-item").addClass("bg-light");
    $(".contest-item .task-icon-button").removeClass("bg-primary").addClass("bg-secondary");
    $(".contest-item .user-link").removeClass("text-white");
  }

  destroy() {
    // Clean up event handlers
    $("#show-more-challenges").off("click");
    $(document).off("click", ".contest-item");
    $(window).off("resize");

    if (this.map) {
      this.map.remove();
    }
  }
}
